import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'ShipSkis: Ship Skis, Snowboards & Gear Worldwide',
  description:
    'Skip the airport hassle. Ship your skis, snowboards, ' +
    'and winter gear worldwide—safe, on time, and stress-free. Your winter, your way.',
  alternates: {
    canonical: 'https://www.shipskis.com',
  },
}

export default metadata
